var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-editor-container"},[_c('vue-editor',{attrs:{"id":"editor","editorOptions":_vm.editorSettings,"editor-toolbar":_vm.editorToolbar},on:{"ready":_vm.initHandlers},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }